import Model from './Model'

export default class Folder extends Model {
  resource() {
    return 'folders'
  }
}
